// index.js
import { combineReducers } from "redux";
import authReducer from "../containers/Auth/authSlice";
import indexReducer from "../containers/Station/IndexPump/indexPumpSlice";
import cuveReducer from "../containers/Station/Cuve/CuveSlice";
import versReducer from "../containers/Station/Versement/VersementSlice";
import retraitReducer from "../containers/Station/RetraitProduit/RetraitProduitSlice";
import retraitArgentReducer from "../containers/Station/RetRemArgent/RetRemArgentSlice";
import quinIndexReducer from "../containers/Quin/quinIndexSlice";
const dummyReducer = (state = {}, action) => state;

const rootReducer = combineReducers({
  user: dummyReducer, // Placeholder reducer for the user state
  posts: dummyReducer, // Placeholder reducer for posts state
  auth: authReducer,
  index: indexReducer,
  cuve: cuveReducer,
  vers: versReducer,
  retraitProduit: retraitReducer,
  retraitArgent: retraitArgentReducer,
  quinIndex: quinIndexReducer,
});

export default rootReducer;
